import { render } from "./BaseFormFieldInput.vue?vue&type=template&id=4c596a5f&scoped=true"
import script from "./BaseFormFieldInput.vue?vue&type=script&lang=ts"
export * from "./BaseFormFieldInput.vue?vue&type=script&lang=ts"

import "./BaseFormFieldInput.vue?vue&type=style&index=0&id=4c596a5f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c596a5f"

export default script